import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp, PieChart, BarChart3 } from 'lucide-react';
import type { DashboardMetrics } from '../utils/calculations';
import { formatCurrency } from '../utils/calculations';
interface MainMetricsProps {
  metrics: DashboardMetrics;
}
export function MainMetrics({
  metrics
}: MainMetricsProps) {
  const profitPositive = metrics.netProfit >= 0;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.2
  }} className="flex flex-col gap-4 h-full" data-id="element-95">
      {/* Gross Margin */}
      <div className="glass-card p-4 flex items-center justify-between group hover:border-white/20 transition-colors" data-id="element-96">
        <div data-id="element-97">
          <div className="flex items-center gap-2 mb-1" data-id="element-98">
            <BarChart3 className="w-4 h-4 text-white/50" data-id="element-99" />
            <h3 className="text-xs font-bold tracking-widest text-white/50 uppercase" data-id="element-100">
              Margen Bruto
            </h3>
          </div>
          <div className={`text-xl font-black tracking-tight ${metrics.grossMargin >= 0 ? 'text-white' : 'text-danger-red'}`} data-id="element-101">
            {metrics.grossMargin < 0 ? '-' : ''}
            {formatCurrency(metrics.grossMargin)}
          </div>
        </div>
      </div>

      {/* Main Goal: Net Profit */}
      <div className={`glass-card p-6 flex-grow flex flex-col justify-center relative overflow-hidden ${profitPositive ? 'border-salmon/30 shadow-glow-salmon' : 'border-danger-red/30 shadow-glow-red'}`} data-id="element-102">
        <div className={`absolute top-0 right-0 w-32 h-32 ${profitPositive ? 'bg-salmon/10' : 'bg-danger-red/10'} rounded-full blur-3xl -mr-10 -mt-10`} data-id="element-103"></div>
        <div className="relative z-10" data-id="element-104">
          <div className="flex items-center gap-2 mb-2" data-id="element-105">
            <div className={`w-2 h-2 rounded-full ${profitPositive ? 'bg-salmon' : 'bg-danger-red'} animate-pulse`} data-id="element-106"></div>
            <h3 className={`text-sm font-bold tracking-widest uppercase ${profitPositive ? 'text-salmon' : 'text-danger-red'}`} data-id="element-107">
              Utilidad Neta
            </h3>
          </div>
          <div className={`text-5xl font-black tracking-tight mb-1 ${profitPositive ? 'text-white' : 'text-danger-red'}`} data-id="element-108">
            {metrics.netProfit < 0 ? '-' : ''}
            {formatCurrency(metrics.netProfit)}
          </div>
          <p className="text-xs text-white/50 font-medium" data-id="element-109">
            {profitPositive ? 'Ganancia por entrega exitosa' : '⚠ Pérdida por entrega — ajusta tus costos'}
          </p>
        </div>
      </div>

      {/* CPA Ideal + Net Margin row */}
      <div className="grid grid-cols-2 gap-3" data-id="element-110">
        <div className="glass-card p-4" data-id="element-111">
          <div className="flex items-center gap-2 mb-1" data-id="element-112">
            <Target className="w-3.5 h-3.5 text-cyber-green" data-id="element-113" />
            <h3 className="text-[10px] font-bold tracking-widest text-white/50 uppercase" data-id="element-114">
              CPA Ideal
            </h3>
          </div>
          <div className="text-xl font-black text-cyber-green tracking-tight" data-id="element-115">
            {formatCurrency(metrics.cpaIdeal)}
          </div>
        </div>
        <div className="glass-card p-4" data-id="element-116">
          <div className="flex items-center gap-2 mb-1" data-id="element-117">
            <PieChart className="w-3.5 h-3.5 text-white/50" data-id="element-118" />
            <h3 className="text-[10px] font-bold tracking-widest text-white/50 uppercase" data-id="element-119">
              Margen Neto
            </h3>
          </div>
          <div className={`text-xl font-bold tracking-tight ${metrics.netMargin >= 0 ? 'text-white' : 'text-danger-red'}`} data-id="element-120">
            {metrics.netMargin.toFixed(2)}%
          </div>
        </div>
      </div>
    </motion.div>;
}